<template>
    <div feedback-page data-layout-type="feedback">
        <header data-header :data-position="layout.HeaderAlignmentPublicName">
            <div data-header-logo>
                <media
                    v-if="layout && layout.LogoImagePath"
                    data-logo
                    :url="state.layout.LogoImagePath"
                    alt="Layout Logo"
                    aria-hidden="true"
                    type="Image"
                    id="logo-image"
                />
            </div>
            <div data-header-image>
                <media
                    v-if="layout.HeaderImagePath"
                    :url="state.layout.HeaderImagePath"
                    alt="Layout Logo"
                    aria-hidden="true"
                    type="Image"
                />
            </div>
        </header>
        <main>
            <div data-main :data-no-top-border-radius="layout && layout.HeaderImagePath !== `` && layout.HeaderImagePath !== null ? `` : null">
                <article
                    v-if="(action === `feedback` && canUnsubscribe === true) || action === `whatsappunsubscribe`"
                    data-form-block
                >
                    <h2>{{this.$store.getters.textResource(`rs_feedback_uitschrijven`)}}</h2>
                    <p
                        v-if="action === `whatsappunsubscribe`"
                        v-html="DOMPurify.sanitize(this.$store.getters.textResource(`rs_whatsapp_uitschrijven_uitleg`))"
                    ></p>
                    <transition name="slide" appear v-if="unsubValidationMessage !== ``">
                        <div data-container>
                            <div data-validation succeed>
                                <div data-icon>
                                    <font-awesome-icon aria-hidden="true" icon="check" />
                                </div>
                                <div data-text>
                                    <strong
                                        role="alert"
                                        v-html="DOMPurify.sanitize(unsubValidationMessage)"
                                    >{{ unsubValidationMessage }}</strong>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <div formcontainer v-if="unsubValidationMessage === `` && !autoConfirm">
                        <div data-formrow>
                            <input
                                type="radio"
                                   id="unsub-survey"
                                   name="unsub-radio"
                                   :checked="true"
                                   v-bind:value="false"
                                v-model="unsubToAll"
                            />
                            <label
                                for="unsub-survey"
                            >{{this.$store.getters.textResource(`rs_feedback_uitschrijven_onderzoek`)}}</label>
                        </div>
                        <div data-formrow>
                            <input
                                type="radio"
                                   id="unsub-all-survey"
                                   name="unsub-radio"
                                   v-bind:value="true"
                                v-model="unsubToAll"
                            />
                            <label
                                for="unsub-all-survey"
                            >{{this.$store.getters.textResource(`rs_feedback_uitschrijven_alle_onderzoeken`)}}</label>
                        </div>
                        <input
                            data-button
                               data-styling-type="secondary"
                               type="button"
                               :value="this.$store.getters.textResource(`rs_feedback_uitschrijven`)"
                            @click.prevent="unsubscribe()"
                        />
                    </div>
                </article>
                <article 
                    v-if="action === `feedback` && canUnsubscribe === false"
                    data-form-block
                >
                    <strong 
                        id="wrong-user-unique-text"
                    >
                        {{this.$store.getters.textResource(`rs_feedback_fout_user_uniek`)}}
                    </strong>
                </article>
                <article
                    v-if="action === `feedbackquestion` || (action === `feedback` && canUnsubscribe === false)"
                    data-form-block
                >
                    <h2>{{this.$store.getters.textResource(`rs_feedback_vraag_opmerking_titel`)}}</h2>
                    <p v-if="questionIsSend === false">{{this.$store.getters.textResource(`rs_feedback_vraag_opmerking_uitleg`)}}</p>
                    <transition name="slide" appear v-if="sendQuestionValidationMessage !== ``">
                        <div data-container>
                            <div data-validation :succeed="questionIsSend ? `` : false">
                                <div data-icon>
                                    <font-awesome-icon
                                        aria-hidden="true"
                                        questionIsSend
                                        :icon="questionIsSend ? `check` : `exclamation-circle` "
                                    />
                                </div>
                                <div data-text>
                                    <strong
                                        role="alert"
                                        v-html="DOMPurify.sanitize(sendQuestionValidationMessage)"
                                    >{{ sendQuestionValidationMessage }}</strong>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <div formcontainer v-if="sendQuestionValidationMessage === ``">
                        <label
                            for="question-name"
                        >{{this.$store.getters.textResource(`rs_feedback_vraag_opmerking_naam`)}}</label>
                        <input type="text" id="question-name" v-model="name" />
                        <label
                            for="question-email"
                        >{{this.$store.getters.textResource(`rs_feedback_vraag_opmerking_email`)}}</label>
                        <input
                            type="email"
                            id="question-email"
                            v-model="email"
                            required
                            @blur="checkForm"
                            :data-invalid="questionEmailValidationMessage.length ? `` : false"
                        />
                        <span
                            data-validate-errors
                            data-validate-field
                            v-if="questionEmailValidationMessage.length"
                            role="alert"
                        >{{questionEmailValidationMessage}}</span>
                        <label
                            id="feedback-message-type-label"
                            for="question-switcher-dropdown"
                            @click.self="dropdownClicked"
                        >{{this.$store.getters.textResource(`rs_feedback_vraag_opmerking_soort_bericht`)}}</label>
                        <div
                            data-dropdown
                            ref="dropdown"
                            @click.self="dropdownClicked"
                            @keydown.enter.exact.prevent="dropdownClicked"
                            @keydown.space.exact.prevent="dropdownClicked"
                            @keydown.prevent.down.exact="move(1, $event)"
                            @keydown.prevent.up.exact="move(-1, $event)"
                            @keydown.esc.exact="focusOut"
                            tabindex="0"
                            id="question-switcher-dropdown"
                            role="combobox"
                            aria-haspopup="listbox"
                            :aria-expanded="selectboxIsExpanded"
                            aria-controls="question-switcher-options"
                            aria-labelledby="feedback-message-type-label question-switcher-current-selection"
                            v-click-outside="focusOut"
                        >
                            <span
                                id="question-switcher-current-selection"
                                @click.self="dropdownClicked"
                                @keydown.space="dropdownClicked"
                            >{{selectedQuestionText}}</span>
                            <font-awesome-icon
                                data-icon
                                :icon="selectboxIsExpanded?`angle-up`:`angle-down`"
                                aria-hidden="true"
                                @click.stop="dropdownClicked"
                            />
                            <ul
                                data-question-list
                                id="question-switcher-options"
                                role="listbox"
                                aria-labelledby="question-switcher-dropdown"
                            >
                                <li
                                    :tabindex="0"
                                    v-for="(question, index) in questions"
                                    :key="question.value"
                                    :id="`question-switcher-option-${question.value}`"
                                    :value="question.value"
                                    role="option"
                                    :aria-selected="selectedQuestionIndex === index"
                                    ref="select-items"
                                    @click.self="optionSelected(question, index, $event)"
                                    @keydown.prevent.space.exact="optionSelected(question, index, $event)"
                                    @keydown.esc.exact="focusOut"
                                    @keydown.enter.exact="optionSelected(question, index, $event)"
                                    @keydown.prevent.tab.exact="move(1, $event)"
                                    @keydown.shift.tab="move(-1, $event)"
                                >{{ DOMPurify.sanitize(question.text) }}</li>
                            </ul>
                        </div>
                        <label
                            for="question-summary"
                        >{{this.$store.getters.textResource(`rs_feedback_vraag_opmerking`)}}</label>
                        <textarea
                            id="question-summary"
                            v-model="summary"
                            @input="checkForm"
                            @keydown="checkForm"
                            @blur="checkForm"
                            :data-invalid="questionSummaryValidationMessage.length ? `` : false"
                        />
                        <span
                            data-validate-errors
                            data-validate-field
                            v-if="questionSummaryValidationMessage.length"
                            role="alert"
                        >{{questionSummaryValidationMessage}}</span>
                        <input
                            data-button
                            data-styling-type="secondary"
                            type="button"
                            :value="this.$store.getters.textResource(`rs_feedback_versturen`)"
                            :disabled="disabled"
                            @click.prevent="sendQuestion"
                        />
                    </div>
                </article>
            </div>
        </main>
        <footer v-if="layout.RemovePoweredBy !== true" data-crowdtech-logo>
             <a :href="state.surveyInfo.culture === `nl-NL` || state.surveyInfo.culture === `nl-jo` ? `https://crowdtech.com/nl/over-crowdtech/pbc/?utm_source=ctsurvey&utm_medium=respondent` : `https://crowdtech.com/about-crowdtech/pbc/?utm_source=ctsurvey&utm_medium=respondent`" target="_blank">
                <media
                    :url="`${state.settings.assetPath}powered-by-crowdtech-logo-${constrastCheck}.svg`"
                    alt="Crowdtech logo"
                    type="Image"
                />
            </a>
        </footer>
    </div>
</template>

<script>
import media from "@/components/Media.vue";
import Vue from "vue";
import VueSanitize from "vue-sanitize";
import store from "@/store/store";
import methods from "@/global/methods.js";

Vue.use(VueSanitize, store.state.global.allowedHtml);

export default {
    name: `feedbackpage-view`,
    inject: ['DOMPurify'],
    components: {
        media,
    },
    data() {
        return {
            selectboxIsExpanded: false,
            unsubToAll: false,
            selectedQuestionText: ``,
            selectedQuestionIndex: 0,
            unsubValidationMessage: "",
            sendQuestionValidationMessage: "",
            questionEmailValidationMessage: "",
            questionSummaryValidationMessage: "",
            questionIsSend: false,
            questionValidationMessage: [],
            name: "",
            email: "",
            summary: "",
            disabled: true,
        };
    },
    computed: {
        state() {
            return this.$store.state;
        },
        autoConfirm() {
            return this.state.surveyInfo.queryParams.autoConfirm === "True";
        },
        surveyInfo: function () {
            return this.state.surveyInfo;
        },
        canUnsubscribe(){
            return this.state.surveyInfo.canUnsubscribe || this.action === `whatsappunsubscribe`;
        },
        layout() {
            return this.state.layout;
        },
        questions() {
            return this.state.surveyInfo.messageTypes;
        },
        constrastCheck: function () {
            return methods.hexToRgb(this.layout.BackgroundColor);
        },
        selectItems() {
            return this.$refs[`select-items`];
        },
        action() {
            return this.state.surveyInfo.queryParams.action;
        }
    },
    methods: {
        checkForm: function (e) {
            let type = e.currentTarget.type;
            if (type === `email`) this.questionEmailValidationMessage = ``;
            if (type === `textarea`) this.questionSummaryValidationMessage = ``;

            if (!this.email && type === `email`) {
                this.questionEmailValidationMessage = this.$store.getters.textResource(`rs_feedback_email_validatie`);
                this.disabled = true;
            } else if (!this.validEmail(this.email) && type === `email`) {
                this.questionEmailValidationMessage = this.$store.getters.textResource(`rs_feedback_email_validatie`);
                this.disabled = true;
            } else if (!this.summary && type === `textarea`) {
                this.questionSummaryValidationMessage = this.$store.getters.textResource(`rs_feedback_vraag_validatie`);
                this.disabled = true;
            }
            if (!this.questionEmailValidationMessage.length && !this.questionSummaryValidationMessage.length && this.email !== `` && this.summary !== ``) {
                this.disabled = false;
                return true;
            }
        },
        validEmail: function (email) {
            let re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        dropdownClicked() {
            this.selectboxIsExpanded = !this.selectboxIsExpanded;
        },
        optionSelected(question, index, e) {
            e.stopPropagation();

            this.selectedQuestionIndex = index;
            this.selectedQuestionText = question.text;
            this.selectboxIsExpanded = false;
        },
        moveFocus(index) {
            this.selectItems[index]?.focus();
        },
        move(targetItem, event) {
            const index = this.selectItems.findIndex((e) => e === event.target);
            this.moveFocus(index + targetItem);
        },
        focusOut() {
            this.selectboxIsExpanded = false;
        },
        unsubClick() {
            this.unsubToAll = !this.unsubToAll;
        },
        sendQuestion() {
            let surveyInfo = this.state.surveyInfo;
            let survey = surveyInfo.surveyId ? `surveyid=${surveyInfo.surveyId}` : ``;
            let respondent = surveyInfo.respondentId ? `&respondentid=${surveyInfo.respondentId}` : ``;
            let questionFields = `recipientName=${this.name}&recipientEmail=${this.email}&messageType=${this.selectedQuestionIndex}&mailMessage=${this.summary}`;

            methods.xhr({
                type: "POST",
                url: `${surveyInfo.domain}/v1/Feedback/SendMessage?${survey}${respondent}&${questionFields}`,
                callback: (xhr) => {
                    let response = JSON.parse(xhr.responseText);
                    this.sendQuestionValidationMessage = response.text;
                    this.questionIsSend = response.success;
                    this.$store.commit(`changeGlobal`, {
                        variableName: `showLoader`,
                        newValue: false,
                    });
                },
            });
        },
        unsubscribe() {
            let queryParams = this.state.surveyInfo.queryParams;
            methods.xhr({
                type: "POST",
                url: `/v1/Feedback/Unsubscribe?surveyid=${queryParams.surveyid}&respondentid=${queryParams.respondentid}&unsubtoall=${this.unsubToAll}`,
                callback: (xhr) => {
                    let response = xhr.responseText;
                    this.unsubValidationMessage = response;
                    this.$store.commit(`changeGlobal`, {
                        variableName: `showLoader`,
                        newValue: false,
                    });
                },
            });
        },
    },
     created() {
        this.$store.commit(`changeGlobal`, {
            variableName: `showLoader`,
            newValue: false,
        });

         this.selectedQuestionText = this.questions[0]?.text;

         if (this.state.surveyInfo.queryParams.autoConfirm) {
             this.unsubToAll = true;
             this.unsubscribe();
         }
    },
};
</script>
<style scoped>
@import "./../styles/variables.css";

[feedback-page] {
    padding: 0 20px;
    main {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 1200px;
        [data-main] {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
        }
    }
}

[data-form-block] {
    width: 450px;
    padding: 0 35px 0 35px;

    article:not(:first-of-type) {
        border-left: 2px dotted #d1d1d1;
    }
}
[data-formrow] {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
    input[type="radio"] {
        width: 18px;
        height: 18px;
        padding: 5px;
        margin: 5px 5px 5px 0;
    }
}

#wrong-user-unique-text {
    color: red;
}

label {
    margin-bottom: 12px;
    margin-top: 12px;
    &[for="unsub-survey"],
    &[for="unsub-all-survey"] {
        margin: 0;
    }
}
[data-invalid] {
    border-bottom: 1px solid red;
    border-bottom-width: 1px !important;
    margin-bottom: -1px;
}

input[type="button"] {
    background-color: var(--next-button-background-color);
    color: var(--next-button-font-color);
    margin: 15px 0;
    width: 150px;
    height: 35px;
}
[data-validation] {
    display: flex;
    flex-direction: row;
    color: red;

    [data-icon],
    [data-text] {
        margin: 3px;
    }

    &[succeed] {
        color: Green;
    }
}

[data-validate-field] {
    display: block;
    color: red;
    margin-top: 7px;
    font-size: 16px;
    [data-validate-errors] {
        padding: 0 0 0 18px;
        margin-top: 0;
        list-style-type: initial;
        li {
            display: list-item;
        }
    }
}

[data-dropdown] {
    position: relative;
    font-size: calc(var(--AnswerStyling-font-size) * 1px);
    width: 100%;
    max-width: 600px;
    pointer-events: all;
    height: 34px;
    box-shadow: 0px -8px 34px 0px rgba(0, 0, 0, 0.05);
    display: flex;
    cursor: pointer;
    justify-content: space-between;
    align-items: center;
    padding: 6px 10px;
    margin-bottom: 5px;
    border: 1px solid #333;
    border-radius: 3px;
    background: #f8f8f8;

    svg {
        pointer-events: none;
    }
}

[data-question-list] {
    background-color: #fff;
    width: 100%;
    max-height: 250px;
    border: 1px solid #d2d2d2;
    border-radius: 0 0 5px 5px;
    border-top: none;
    box-shadow: 0px -8px 34px 0px rgba(0, 0, 0, 0.05);
    overflow: auto;
    padding: 0;
    z-index: 1;
    padding-top: 2px;
    margin: 0 0 0 -2px;
    width: calc(100% + 4px);
    min-width: 300px;
    position: absolute;
    display: none;
    left: 0;
    top: 33px;

    &[aria-expanded] {
        display: block;
    }

    &::-webkit-scrollbar {
        -webkit-appearance: none;
    }

    &::-webkit-scrollbar:vertical {
        width: 12px;
    }

    &::-webkit-scrollbar:horizontal {
        height: 12px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 10px;
        border: 2px solid #ffffff;
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #ffffff;
    }

    li {
        font-family: var(--page-font-family-public-name);
        color: #454848;
        line-height: 1.5em;
        padding: 8px;
        text-decoration: none;
        width: 100%;
        display: block;
        cursor: pointer;

        &:nth-child(odd) {
            background: #f7f7f7;
        }

        &:hover {
            background-color: var(--primary-color);
        }
    }
}

@media only screen and (max-width: 961px) {
    [data-main] {
        flex-wrap: wrap;
    }
}

@media only screen and (max-width: 550px) {
    body [feedback-page] {
        padding: 0;
    }

    [data-form-block] {
        padding: 0;
    }

    [data-formrow] {
        padding: 10px 0;
    }
}
</style>